import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rounded shadow bg-white justify-center block p-4 h-44" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "py-3 font-semibold flex text-sm justify-start mt-1" }, " Next subscription billing date ")
], -1)
const _hoisted_3 = { class: "text-xl font-semibold flex justify-start" }
const _hoisted_4 = { class: "text-md font-medium text-gray-400 flex justify-start p-1" }
const _hoisted_5 = { class: "text-md text-gray-400 font-medium flex justify-start p-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("span", _hoisted_3, "$" + _toDisplayString(_ctx.amount) + " " + _toDisplayString(_ctx.country === "usa" ? "USD" : "MXN"), 1),
    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.plan), 1),
    _createElementVNode("span", _hoisted_5, "On " + _toDisplayString(_ctx.date), 1)
  ]))
}